<script>
import { isImminent, isEnded } from '../../utils/Time';
export default {
  name: 'RelativeTimePunters',
  props: {
    // eslint-disable-next-line vue/require-prop-types
    targetTime: {
      required: true,
    },
    // eslint-disable-next-line vue/require-prop-types
    currentTime: {
      required: true,
    },
    isResulted: {
      required: true,
      type: Boolean,
    },
  },
  computed: {
    imminent() {
      return isImminent(this.targetTime);
    },
    isEnded() {
      return isEnded(this.targetTime);
    },
    relativeTimeClass() {
      const { targetTime, isResulted, underTen } = this;
      const isImminentVal = isImminent(targetTime);
      const isEndedVal = isEnded(targetTime);
      const underTenVal = underTen(targetTime);
      if (underTenVal) {
        return 'under-10';
      }

      if (isImminentVal && !underTenVal) {
        return 'under-60';
      }

      if (isEndedVal && !isResulted) {
        return 'past';
      }

      if (isResulted) {
        return 'resulted';
      }
    },
  },
  methods: {
    // under 10 mins
    underTen() {
      return isImminent(this.targetTime, 600);
    },
  },
};
</script>

<template>
  <abbr :data-ticking="currentTime" :class="`${relativeTimeClass} relative-time__inner`">
    <span v-if="isResulted">Resulted</span>
    <span v-else>{{ targetTime | countdownPunters }}</span>
  </abbr>
</template>
